import React from 'react';

import SidePanelAccordionItemContentCard from './AccordionItemContent/SidePanelAccordionItemContentCard';

import styles from './SidePanelAccordionItem.css';

type SidePanelAccordionItemChildrenProps = {
    itemData: SidePanelAccordionItemContentCardData[];
    noDataMessage?: string;
    expanded?: boolean;
};

const SidePanelAccordionItemChildren = ({ expanded, itemData, noDataMessage }: SidePanelAccordionItemChildrenProps) => {
    const [expandedCardIndex, setExpandedCardIndex] = React.useState(-1);

    const handleCardHeaderOnClick = (cardIndex: number, isCardExpanded: boolean) => {
        if (isCardExpanded) {
            setExpandedCardIndex(-1);
        } else setExpandedCardIndex(cardIndex);
    };

    return (
        <>
            {expanded &&
                (itemData.length > 0 ? (
                    itemData.map((item, index) => {
                        const uid = `sidePanelContentCard-${index}`;

                        return (
                            <SidePanelAccordionItemContentCard
                                key={uid}
                                id={index}
                                itemData={item}
                                expandedCardIndex={expandedCardIndex}
                                handleCardHeaderOnClick={handleCardHeaderOnClick}
                            />
                        );
                    })
                ) : (
                    <div className={styles.accordionItemNoData} data-testid='no-data-message'>
                        <p className={styles.noDataText}>{noDataMessage}</p>
                    </div>
                ))}
        </>
    );
};

export default SidePanelAccordionItemChildren;
